import './index.scss';

import img8 from '../../assets/static/images/8.png';
import img9 from '../../assets/static/images/9.png';
import img11 from '../../assets/static/images/11.png';
import auroraMigrationFlowImg from '../../assets/static/images/aurora-migration-flow.svg';
import auroraMigrationFlowMobileImg from '../../assets/static/images/aurora-migration-flow-mobile.svg';
import infraMigrationImg from '../../assets/static/images/infra-migration.png';
import integratedSearchArchitectureImg from '../../assets/static/images/integrated-search-architecture.svg';
import integratedSearchArchitectureMobileImg from '../../assets/static/images/integrated-search-architecture-mobile.svg';
import fargateArchitectureImg from '../../assets/static/images/ecs-fargate-architecture.svg';
import fargateArchitectureMobileImg from '../../assets/static/images/ecs-fargate-architecture-mobile.svg';
import stepFunctionsImg from '../../assets/static/images/step-functions.png';
import tpsImg from '../../assets/static/images/tps.png';
import myData from '../../db.json';
import ProjectItem from './ProjectItem';

const projectImages = {
  2: tpsImg,
  8: img8,
  9: infraMigrationImg,
  14: img9,
  12: img11,
  11: stepFunctionsImg,
  15: auroraMigrationFlowImg,
  16: integratedSearchArchitectureImg,
  18: fargateArchitectureImg,
};

const projectMobileImages = {
  15: auroraMigrationFlowMobileImg,
  16: integratedSearchArchitectureMobileImg,
  18: fargateArchitectureMobileImg,
};

const projectImageAlts = {
  15: '기존 RDS에서 DMS CDC를 거쳐 Aurora Writer·Reader 구조로 전환하는 흐름',
  16: '36만 개 이상의 제휴링크 데이터를 정제해 검색·피드백·링크 생성으로 연결하는 통합 검색 흐름',
  18: 'Terraform 기반 ECS Fargate의 배포 경로, ALB·Target Group 요청 흐름과 FireLens 로그 라우팅 구조',
};

const Project = () => {
  const { projects } = myData;

  return (
    <section className='projects-section'>
      <p className='section-label'>3 | 프로젝트</p>
      {projects && (
        <div className='projects-container'>
          {projects.map((project) => (
            <ProjectItem
              key={project.id}
              {...project}
              image={projectImages[project.id]}
              mobileImage={projectMobileImages[project.id]}
              imageAlt={projectImageAlts[project.id]}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default Project;
